import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const fetchSuiteAreasDone = (_, { payload }) => {
    return [
      ...payload,
    ]
  };

  const initialState = [];
  export default createReducer(initialState, {
    [TYPES.FETCH_SUITE_AREAS_DONE] : fetchSuiteAreasDone
  });